import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  role: "list",
  class: "space-y-6"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-px bg-gray-200" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "relative flex h-6 w-6 flex-none items-center justify-center bg-white" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "h-1.5 w-1.5 rounded-full bg-gray-100 ring-1 ring-gray-300" })
], -1)
const _hoisted_6 = { class: "flex-auto" }
const _hoisted_7 = { class: "flex justify-between gap-x-4" }
const _hoisted_8 = { class: "py-0.5 text-xs leading-5 text-gray-500" }
const _hoisted_9 = { class: "font-medium text-gray-900" }
const _hoisted_10 = { class: "flex flex-row items-center gap-2" }
const _hoisted_11 = ["datetime"]
const _hoisted_12 = { class: "py-1 divide-y" }
const _hoisted_13 = { class: "ml-1" }
const _hoisted_14 = { class: "text-sm leading-6 text-gray-500 whitespace-pre-wrap" }
const _hoisted_15 = { class: "relative flex-auto" }
const _hoisted_16 = { class: "overflow-hidden rounded-lg pb-12 shadow-sm ring-1 ring-inset ring-gray-300 focus-within:ring-2 focus-within:ring-indigo-600" }
const _hoisted_17 = {
  for: "comment",
  class: "sr-only"
}
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = { class: "absolute inset-x-0 bottom-0 flex justify-end py-2 pl-3 pr-2" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = {
  key: 1,
  class: "flex flex-col items-center gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EllipsisVerticalIcon = _resolveComponent("EllipsisVerticalIcon")!
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_MenuItem = _resolveComponent("MenuItem")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_LoadingSpinner = _resolveComponent("LoadingSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("ul", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comments, (plannerComment, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: plannerComment._id,
                class: "relative flex gap-x-4"
              }, [
                _createElementVNode("div", {
                  class: _normalizeClass([
            index === _ctx.comments.length - 1 ? 'h-6' : '-bottom-6',
            'absolute left-0 top-0 flex w-6 justify-center',
          ])
                }, _hoisted_4, 2),
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(plannerComment.created_by_name || plannerComment.created_by), 1),
                      _createTextVNode(" " + _toDisplayString(_ctx.$t("analytics.planner.comments.commented")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", {
                        datetime: plannerComment.created,
                        class: "flex-none py-0.5 text-xs leading-5 text-gray-500"
                      }, _toDisplayString(_ctx.formatInTimeAgo(plannerComment.created)), 9, _hoisted_11),
                      _createVNode(_component_Menu, {
                        as: "div",
                        class: "inline-block text-left leading-none"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_MenuButton, { class: "flex items-center rounded-full text-gray-500 hover:text-gray-600" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_EllipsisVerticalIcon, {
                                class: "h-6 w-6",
                                "aria-hidden": "true"
                              })
                            ]),
                            _: 1
                          }),
                          _createVNode(_Transition, {
                            "enter-active-class": "transition ease-out duration-100",
                            "enter-from-class": "transform opacity-0 scale-95",
                            "enter-to-class": "transform opacity-100 scale-100",
                            "leave-active-class": "transition ease-in duration-75",
                            "leave-from-class": "transform opacity-100 scale-100",
                            "leave-to-class": "transform opacity-0 scale-95"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_MenuItems, { class: "absolute right-5 z-10 mt-2 w-35 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-gray/5 focus:outline-none" }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_12, [
                                    (plannerComment.created_by === _ctx.email)
                                      ? (_openBlock(), _createBlock(_component_MenuItem, {
                                          key: 0,
                                          onClick: ($event: any) => (_ctx.handleDeleteClick(plannerComment))
                                        }, {
                                          default: _withCtx(({ active }) => [
                                            _createElementVNode("a", {
                                              href: "#",
                                              class: _normalizeClass([
                            active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                            'group flex items-center px-4 py-2 text-sm',
                          ])
                                            }, [
                                              _createVNode(_component_TrashIcon, { class: "w-4 h-4 text-gray-600" }),
                                              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("analytics.planner.comments.delete_comment_menu_item")), 1)
                                            ], 2)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(plannerComment.comment), 1)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["mt-6 flex gap-x-3", [_ctx.comments.length > 0 ? 'ml-9' : '']])
          }, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("analytics.planner.comments.add_comment_label")), 1),
                _withDirectives(_createElementVNode("textarea", {
                  rows: "2",
                  class: "block w-full resize-none border-0 bg-transparent py-1.5 text-gray-900 placeholder:text-gray-400 focus:ring-0 sm:text-sm sm:leading-6",
                  placeholder: `${_ctx.$t('analytics.planner.comments.add_comment_label')}...`,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
                  maxlength: "10240"
                }, null, 8, _hoisted_18), [
                  [_vModelText, _ctx.comment]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  type: "button",
                  class: _normalizeClass(["rounded-md bg-white px-2.5 py-1.5 text-sm font-semibold shadow-sm ring-1 ring-inset ring-gray-300", [
              _ctx.isCommentButtonEnabled
                ? 'hover:bg-gray-50 text-gray-900'
                : 'cursor-default text-gray-300',
            ]]),
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.createComment && _ctx.createComment(...args))),
                  disabled: !_ctx.isCommentButtonEnabled
                }, _toDisplayString(_ctx.$t("buttons.comment")), 11, _hoisted_20)
              ])
            ])
          ], 2)
        ]))
      : _createCommentVNode("", true),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createVNode(_component_LoadingSpinner),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t("analytics.planner.comments.loading_message")), 1)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}